import type { TaskResult } from "../types";

function normalizeFormula(value: string | undefined): string {
  return (value ?? "").replace(/\$/g, "").replace(/\s+/g, "").replace(/^=/, "").toUpperCase();
}

export async function gradeProject21(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Vendido");
      const headerA = sheet.getRange("A3");
      const headerB = sheet.getRange("B3");
      headerA.load("values");
      headerB.load("values");
      await context.sync();

      results.push({
        taskId: 1,
        passed:
          String(headerA.values[0][0] ?? "") === "" &&
          String(headerB.values[0][0] ?? "").toUpperCase().includes("TIPO DE ART"),
      });
    });
  } catch {
    results.push({ taskId: 1, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const window = context.workbook.application.windows.getItemAt(0);
      window.load("split,splitRow");
      await context.sync();

      results.push({ taskId: 2, passed: window.split === true && window.splitRow === 6 });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Vehículos");
      const frozen = sheet.freezePanes.getLocationOrNullObject();
      frozen.load("rowCount,address");
      await context.sync();

      results.push({
        taskId: 3,
        passed:
          !frozen.isNullObject &&
          (frozen.rowCount === 3 || String(frozen.address).toUpperCase().includes("1:3")),
      });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const table = context.workbook.worksheets.getItem("Vendido").tables.getItemAt(0);
      table.load("showBandedRows");
      await context.sync();

      results.push({ taskId: 4, passed: table.showBandedRows === true });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const cell = context.workbook.worksheets.getItem("Vehículos").getRange("B4");
      cell.load("formulas,values");
      await context.sync();

      const formula = normalizeFormula(String(cell.formulas[0][0] ?? ""));
      const value = String(cell.values[0][0] ?? "").trim();
      // Aceptar LEFT/IZQUIERDA con referencia de celda o estructurada ([@[Lote#]])
      const hasFn = formula.includes("LEFT(") || formula.includes("IZQUIERDA(");
      const hasTwo = formula.includes(",2") || formula.includes(";2");
      results.push({
        taskId: 5,
        passed: hasFn && hasTwo && value === "HF",
      });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
